import type { Moment } from 'moment';
import { toMoment } from './date';

type VoyageRedeliveryFields = {
	redeliveryDate?: Moment | string | null;
	isRedeliveryDateEstimated?: boolean | null;
};

/**
 * The ACTUAL redelivery datetime of a contract, or null when only an estimated
 * redelivery date is known (or none at all). Hire may only be invoiced up to and
 * including this datetime; when it is null users may invoice as they wish.
 *
 * Works for TC OUT, TC IN and BB OUT. For a TC IN the redelivery date is propagated
 * from the linked outbound (TC OUT / VC OUT) contract's final-port actual departure
 * via the port action handlers, so `isRedeliveryDateEstimated === false` reliably
 * signals that an actual redelivery date has been entered.
 */
const getActualRedeliveryDate = (voyage: VoyageRedeliveryFields): Moment | null => {
	if (voyage.isRedeliveryDateEstimated !== false || voyage.redeliveryDate == null) {
		return null;
	}

	return toMoment(voyage.redeliveryDate);
};

export default getActualRedeliveryDate;
